import React from 'react';
import OperatorList from './OperatorList';
import WeeklyChosenOperator from './WeeklyChosenOperator';

const OperatorsMain = () => {
  return (
    <div className='operators__list'>
      <WeeklyChosenOperator />
      <OperatorList />
    </div>
  );
};

export default OperatorsMain;
